import { Link } from "react-router-dom";
import { TELEGRAM_URL } from "../../config/links";
import { BackLink } from "./BookScreen";

const ROW = "flex items-center justify-between gap-4 rounded-xl border border-[#d8c9a6] bg-[#fffdf8] px-5 py-4 text-[15px] font-semibold text-[#17130c] transition-[border-color,transform,box-shadow] duration-200 hover:-translate-y-px hover:border-[#b88a24] hover:shadow-[0_8px_20px_-10px_rgba(138,100,22,0.6)]";

export const ResourcesScreen = ({ onBack }) => (
  <div data-testid="apply-resources-screen">
    <p className="font-mono-plex text-[11px] tracking-[0.16em] text-[#8a6416]">Thanks for being honest</p>
    <h2 className="font-display mt-3 text-5xl uppercase leading-none text-[#120e07] sm:text-6xl">Start here for now</h2>
    <p className="mt-4 text-[15px] leading-relaxed text-[#4a3f2a]">The mentorship is a real investment, and it should only happen when the timing is right. Until then, here are the best places to keep building your knowledge:</p>
    <div className="mt-6 grid gap-3">
      <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" className={ROW} data-testid="resources-telegram-link">
        <span>Join the free Telegram community →</span>
      </a>
      <Link to="/bridge#toolkit" className={ROW} data-testid="resources-toolkit-link">
        <span>Get the Weaponized Credit Toolkit →</span>
      </Link>
    </div>
    <p className="mt-6 text-[15px] leading-relaxed text-[#4a3f2a]">When you're ready, come back and apply again. We'll be here.</p>
    <BackLink onClick={onBack} testid="apply-change-answers-button">← Change my answers</BackLink>
  </div>
);
